import { Link } from '@larvitu/shared/next/mui';
import { Box } from '@mui/material';

import type { HeaderContextProps } from '@larvitu/shared/react/context/feature-header-context';
import type { BoxProps } from '@mui/material';
import type { LinkProps } from 'next/link';
import type { FC, ReactElement } from 'react';

export interface SiteBrandingProps extends BoxProps, Omit<Partial<HeaderContextProps>, 'height'> {
  href: LinkProps['href'];
  logo?: ReactElement;
  label?: ReactElement;
  isScrolling?: boolean;
}

export const SiteBranding: FC<SiteBrandingProps> = ({
  href,
  isScrolling = false,
  sx,
  logo,
  label,
  ...props
}) => (
  <Link
    sx={{
      ml: 0,
      mr: 'auto',
    }}
    ml={0}
    mr="auto"
    noLinkStyle
    href={href}
  >
    <Box
      sx={{
        ...sx,
        lineHeight: 0,
        position: 'relative',
        display: 'flex',
      }}
      {...props}
    >
      {logo}
      {label}
    </Box>
  </Link>
);
